export default {
  id: 'healthHistory/PAST_ILLNESS/v1',
  formSchema: {
    title: 'encounter:widget.healthHistory.pastIllness',
    type: 'object',
    required: ['id001'],
    properties: {
      id001: {
        type: 'string',
        title: 'encounter:widget.healthHistory.pastIllness',
        minLength: 1
      }
    }
  },
  uiSchema: {
    id001: { 'ui:widget': 'customCKEditorWidget' },
    'x-customClass': 'problem-description-widget'
  }
};
